import { Divider, styled } from "@mui/material";

export default styled(Divider)(() => ({
  borderBottomWidth: "2px",
  borderColor: "#C7C7C7",
}));
